export class DISCLAIMER_BLOCK_NAMES {
  static readonly TITLE_BLOCK = 'titleBlock';
  static readonly SUBTITLE_BLOCK = 'subTitleBlock';
  static readonly DESCRIPTION_BLOCK = 'descriptionBlock';
  static readonly ICON_BLOCK = 'iconBlock';
  static readonly SPACE_BLOCK = 'spaceBlock';
}
